import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import type { CustomFieldsLevel } from 'hooks/useCustomFieldRules';

type DeleteCustomFieldConfirmDialogProps = {
  open: boolean;
  level: CustomFieldsLevel;
  onConfirm: () => void;
  onCancel: () => void;
};

export function DeleteCustomFieldConfirmDialog({ open, level, onConfirm, onCancel }: DeleteCustomFieldConfirmDialogProps) {
  const { t } = useTranslation();

  const bodyKey =
    level === 'template' ? 'editor.variables.delete_custom_field_body_template' : 'editor.variables.delete_custom_field_body_document';

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" fontWeight={600}>
          {t('editor.variables.delete_custom_field_title')}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Typography variant="body2" color="text.secondary">
          {t(bodyKey)}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button onClick={onCancel} variant="outlined" color="inherit">
          {t('cancel', 'Cancel')}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          {t('editor.variables.delete_custom_field_confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
